// 静态文件地址
export const STATIC_URL = "https://statres.wk1762.com"